import DownloadRefundPDF from "@/components/common/RefundPDF";
import { Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { Box, Text, Accordion } from "@/ui";
import { useSystemContext } from "@/provider/common/SystemProvider";
import { FilterPeriodMobile } from "./DateFilter";
import { useTheme } from "@mui/material";
import { useQueryParams } from "@/utils/useQueryParams";
import { formatUTC } from "@/utils/format";
import { PraticienSelector } from "@/components/common/PraticienSelector";

function RefundItemMobile({ refund }: { refund: any }) {
  const RefundHeaderMobile = () => (
    <Box flexDirection="row" justifyContent="space-between" alignItems="center" width="100%" style={{ paddingRight: 8 }}>
      <Text fontSize={12} fontWeight="600">
        {formatUTC(refund.date, "dd/MM/yyyy")} - {refund.nom_organisme}
      </Text>
      <Text fontSize={14} fontWeight="700" color="#FF008D">
        {parseFloat(refund.total).toFixed(2)} €
      </Text>
    </Box>
  );

  return (
    <Box width="100%" py={1} justifyContent="center" alignItems="center">
      <Accordion width="99%" title={`refund-${refund.remboursement_id}`} HeaderComponent={RefundHeaderMobile} boxShadow="none">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ padding: 4 }}>Facture</TableCell>
              <TableCell style={{ padding: 4 }}>Patient</TableCell>
              <TableCell style={{ padding: 4 }}>Date</TableCell>
              <TableCell style={{ padding: 4 }}>Payé</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {refund.details_remboursements.map((detail, detailIndex) => (
              <TableRow
                key={detail.detail_id || detailIndex}
                style={{
                  backgroundColor: detailIndex % 2 === 0 ? "#fff" : "#f3e7e765",
                }}
              >
                <TableCell style={{ padding: 4 }}>
                  <Text fontSize={12}>{detail.num_facture}</Text>
                </TableCell>
                <TableCell style={{ padding: 4 }}>
                  <Text fontSize={12}>{detail.nom_patient || detail.factures?.nom_patient || "-"}</Text>
                </TableCell>
                <TableCell style={{ padding: 4 }}>
                  <Text fontSize={12}>
                    {formatUTC(detail.date_debut, "dd/MM/yyyy")} - {formatUTC(detail.date_fin, "dd/MM/yyyy")}
                  </Text>
                </TableCell>
                <TableCell style={{ padding: 4 }}>
                  <Text fontSize={12}>{parseFloat(detail.montant_paye).toFixed(2)}€</Text>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Accordion>
    </Box>
  );
}

export function RefundViewMobileCpn({ refunds, pluralize }: any) {
  const { getUser } = useSystemContext();
  const theme = useTheme();
  const params = useQueryParams();

  return (
    <>
      <Box
        width="100%"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        height="90px"
        pr={3}
        borderBottom={`solid 1px ${theme.palette.primary.light}`}
      >
        <Box flexDirection="column">
          <Text fontSize={28} fontWeight="800" paddingLeft="70px">
            <span style={{ color: theme.palette.primary.main }}>G</span>
            estion <span style={{ color: theme.palette.primary.main }}>C</span>
            ofidoc,
          </Text>
          <Text fontSize={16} fontWeight="300" paddingLeft="70px">
            Mes remboursements
          </Text>
        </Box>
      </Box>
      <Box
        width="100%"
        flexDirection="column"
        height="calc(100% - 90px)"
        px={3}
        style={{ overflowY: "scroll", overflowX: "hidden" }}
        className="hiddenScrollBarAndChildren"
      >
      <Box width="100%" pt={2}>
        <PraticienSelector variant="full" showLabel={false} />
      </Box>
        <FilterPeriodMobile />

        {refunds?.length > 0 ? (
          <>
            <Box flexDirection="row" justifyContent="space-between" alignItems="center" mb={2}>
              <DownloadRefundPDF data={refunds} period={params.period} currentUser={getUser()} />
              <Box flexDirection="column" alignItems="flex-end">
                <Text fontSize={16} fontWeight="700" color={theme.palette.primary.main}>
                  {refunds.reduce((acc, refund) => {
                    const total = refund?.total ? parseFloat(refund.total) : 0;
                    let number = Number(acc + total).toFixed(2);
                    return Number(number);
                  }, 0)}{" "}
                  €
                </Text>
                {/* <Text fontSize={11} color={theme.palette.grey[600]}>
                  {refunds.length} {pluralize(refunds.length, "virement", "virements")} -{" "}
                  {refunds.filter((refund, index, self) => self.findIndex((r) => r.nom_organisme === refund.nom_organisme) === index).length}{" "}
                  {pluralize(
                    refunds.filter((refund, index, self) => self.findIndex((r) => r.nom_organisme === refund.nom_organisme) === index).length,
                    "organisme",
                    "organismes",
                  )}
                </Text> */}
              </Box>
            </Box>

            {refunds.map((refund, index) => (
              <RefundItemMobile key={refund.remboursement_id || index} refund={refund} />
            ))}
          </>
        ) : (
          <Box justifyContent="center" alignItems="center" width="100%" p={2}>
            <Text fontSize={18} fontWeight={500}>
              Aucun remboursement pour cette période
            </Text>
          </Box>
        )}
      </Box>
    </>
  );
}
